/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PriceList,
  PriceListList,
  PriceListNew,
  PriceListProduct,
  UpdatePriceListProductPriceRequest,
} from '../models/index';
import {
    PriceListFromJSON,
    PriceListToJSON,
    PriceListListFromJSON,
    PriceListListToJSON,
    PriceListNewFromJSON,
    PriceListNewToJSON,
    PriceListProductFromJSON,
    PriceListProductToJSON,
    UpdatePriceListProductPriceRequestFromJSON,
    UpdatePriceListProductPriceRequestToJSON,
} from '../models/index';

export interface CopyPriceListRequest {
    priceListId: number;
    priceListNew: PriceListNew;
}

export interface CreatePriceListRequest {
    priceListNew: PriceListNew;
}

export interface DeletePriceListRequest {
    priceListId: number;
}

export interface GetPriceListRequest {
    priceListId: number;
}

export interface GetPriceListProductsRequest {
    priceListId: number;
}

export interface PublishPriceListRequest {
    priceListId: number;
}

export interface UpdatePriceListRequest {
    priceListId: number;
    priceListNew: PriceListNew;
}

export interface UpdatePriceListProductsRequest {
    priceListId: number;
    updatePriceListProductPriceRequest: UpdatePriceListProductPriceRequest;
}

/**
 * 
 */
export class PriceListsApi extends runtime.BaseAPI {

    /**
     */
    async copyPriceListRaw(requestParameters: CopyPriceListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['priceListId'] == null) {
            throw new runtime.RequiredError(
                'priceListId',
                'Required parameter "priceListId" was null or undefined when calling copyPriceList().'
            );
        }

        if (requestParameters['priceListNew'] == null) {
            throw new runtime.RequiredError(
                'priceListNew',
                'Required parameter "priceListNew" was null or undefined when calling copyPriceList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/priceLists/{priceListId}/copy`;
        urlPath = urlPath.replace(`{${"priceListId"}}`, encodeURIComponent(String(requestParameters['priceListId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PriceListNewToJSON(requestParameters['priceListNew']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async copyPriceList(requestParameters: CopyPriceListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.copyPriceListRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createPriceListRaw(requestParameters: CreatePriceListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['priceListNew'] == null) {
            throw new runtime.RequiredError(
                'priceListNew',
                'Required parameter "priceListNew" was null or undefined when calling createPriceList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/priceLists`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PriceListNewToJSON(requestParameters['priceListNew']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createPriceList(requestParameters: CreatePriceListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createPriceListRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deletePriceListRaw(requestParameters: DeletePriceListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['priceListId'] == null) {
            throw new runtime.RequiredError(
                'priceListId',
                'Required parameter "priceListId" was null or undefined when calling deletePriceList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/priceLists/{priceListId}`;
        urlPath = urlPath.replace(`{${"priceListId"}}`, encodeURIComponent(String(requestParameters['priceListId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deletePriceList(requestParameters: DeletePriceListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePriceListRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getCurrentPriceListProductsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PriceListProduct>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/priceLists/current/products`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PriceListProductFromJSON));
    }

    /**
     */
    async getCurrentPriceListProducts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PriceListProduct>> {
        const response = await this.getCurrentPriceListProductsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getPriceListRaw(requestParameters: GetPriceListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PriceList>> {
        if (requestParameters['priceListId'] == null) {
            throw new runtime.RequiredError(
                'priceListId',
                'Required parameter "priceListId" was null or undefined when calling getPriceList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/priceLists/{priceListId}`;
        urlPath = urlPath.replace(`{${"priceListId"}}`, encodeURIComponent(String(requestParameters['priceListId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PriceListFromJSON(jsonValue));
    }

    /**
     */
    async getPriceList(requestParameters: GetPriceListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PriceList> {
        const response = await this.getPriceListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPriceListProductsRaw(requestParameters: GetPriceListProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PriceListProduct>>> {
        if (requestParameters['priceListId'] == null) {
            throw new runtime.RequiredError(
                'priceListId',
                'Required parameter "priceListId" was null or undefined when calling getPriceListProducts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/priceLists/{priceListId}/products`;
        urlPath = urlPath.replace(`{${"priceListId"}}`, encodeURIComponent(String(requestParameters['priceListId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PriceListProductFromJSON));
    }

    /**
     */
    async getPriceListProducts(requestParameters: GetPriceListProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PriceListProduct>> {
        const response = await this.getPriceListProductsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPriceListsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PriceListList>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/priceLists`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PriceListListFromJSON));
    }

    /**
     */
    async getPriceLists(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PriceListList>> {
        const response = await this.getPriceListsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async publishPriceListRaw(requestParameters: PublishPriceListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['priceListId'] == null) {
            throw new runtime.RequiredError(
                'priceListId',
                'Required parameter "priceListId" was null or undefined when calling publishPriceList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/priceLists/{priceListId}/publish`;
        urlPath = urlPath.replace(`{${"priceListId"}}`, encodeURIComponent(String(requestParameters['priceListId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async publishPriceList(requestParameters: PublishPriceListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.publishPriceListRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updatePriceListRaw(requestParameters: UpdatePriceListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['priceListId'] == null) {
            throw new runtime.RequiredError(
                'priceListId',
                'Required parameter "priceListId" was null or undefined when calling updatePriceList().'
            );
        }

        if (requestParameters['priceListNew'] == null) {
            throw new runtime.RequiredError(
                'priceListNew',
                'Required parameter "priceListNew" was null or undefined when calling updatePriceList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/priceLists/{priceListId}`;
        urlPath = urlPath.replace(`{${"priceListId"}}`, encodeURIComponent(String(requestParameters['priceListId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PriceListNewToJSON(requestParameters['priceListNew']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updatePriceList(requestParameters: UpdatePriceListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePriceListRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updatePriceListProductsRaw(requestParameters: UpdatePriceListProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['priceListId'] == null) {
            throw new runtime.RequiredError(
                'priceListId',
                'Required parameter "priceListId" was null or undefined when calling updatePriceListProducts().'
            );
        }

        if (requestParameters['updatePriceListProductPriceRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePriceListProductPriceRequest',
                'Required parameter "updatePriceListProductPriceRequest" was null or undefined when calling updatePriceListProducts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/priceLists/{priceListId}/products`;
        urlPath = urlPath.replace(`{${"priceListId"}}`, encodeURIComponent(String(requestParameters['priceListId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePriceListProductPriceRequestToJSON(requestParameters['updatePriceListProductPriceRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updatePriceListProducts(requestParameters: UpdatePriceListProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePriceListProductsRaw(requestParameters, initOverrides);
    }

}
